<template>
  <div id="complain">
    <y-d-f-y-tab-bar :webPageTrans='false' />
    <div class="container" v-if="!complainSuccess">
      <h5>投诉网址 <span class="segmentation"></span> <span class="required">必填</span></h5>
      <el-input placeholder="请输入内容" v-model="complanUrl" :class="[complanUrlWrong ? 'content_right' : 'content_wrong']"></el-input>
      <p>请选择投诉原因<span class="segmentation"></span><span class="required">必填</span></p>
      <ul>
        <li class="complan_reason" v-for="(item, index) in complanReasonOptions" :key="index">
          <el-radio v-model="complanReason" :label="item">{{item}}</el-radio>
        </li>
      </ul>
      <p class="question_desc">描述<span class="segmentation"></span><span class="optional">选填</span></p>
      <el-input type="textarea" placeholder="请输入投诉原因" maxlength="200" v-model="complanDesc" show-word-limit></el-input>
      <p>联系方式<span class="segmentation"></span><span class="required">必填</span></p>
      <div class="contact">
        <div class="contact_way" v-for="(item, index) in contactOptions" :key="index" @click="changeContactWay(index)">
          <img :src="item.img" v-if="!item.selected"/>
          <img :src="item.selectImg" v-if="item.selected"/>
        </div>
      </div>
      <el-input v-model="contact" ref="contact" placeholder="请输入你的联系方式" :class="[contactWrong ? 'content_right' : 'content_wrong']"></el-input>
      <button :class="[canSubmit ? 'can_submit' : 'no_submit']" @click="submit">提交</button>
    </div>
    <div class="complain_success" v-if="complainSuccess">
      <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/Web_icon_succeed.png" alt="">
      <h5>投诉成功</h5>
      <p>我们将尽快核实投诉信息，核实后将对该网站采取屏蔽</p>
      <p>措施，感谢您的反馈！<span>{{timeTurn}}秒后跳转到有道翻译首页…</span></p>
    </div>
    <footer>
      <y-d-f-y-footer-bar />
    </footer>

<div class="condition">
      <input type="radio">
      <input type="radio">
</div>
  </div>
</template>

<script>
import YDFYTabBar from "./../components/YDFYTabBar";
import YDFYFooterBar from "./../components/YDFYFooterBar";
import { fanyiComplain } from './../services/index.js'
import { clearInterval } from 'timers';
import { checkLink } from "./../libs/utils.js";
export default {
  name: "Complain",
  data() {
    return {
      complanUrl: "",
      complanUrlWrong: true,
      complainSuccess: false,
      contactWrong: true,
      complanReason: "",
      complanDesc: "",
      contact: "",
      canSubmit: false,
      timeTurn: 5,
      contactWay: '手机',
      contactOptions: [
        {
          val: "手机",
          selected: true,
          img: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_iphone.png',
          selectImg: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_phoneSelected.png'
        },
        {
          val: "微信",
          selected: false,
          img: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_wech.png',
          selectImg: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_wechatSelected.png'
        },
        {
          val: "微博",
          selected: false,
          img: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_weibo.png',
          selectImg: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_weiboSelected.png'
        },
        {
          val: "QQ",
          selected: false,
          img: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_qq.png',
          selectImg: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_qqSelected.png'
        },
        {
          val: "邮箱",
          selected: false,
          img: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_youxiang.png',
          selectImg: 'https://shared-https.ydstatic.com/dict/market/webTransPc/images/login_ic_youxiangSelected.png'
        }
      ],
      complanReasonOptions: [
        "网页包含欺诈信息",
        "网页包含色情信息",
        "网页包含不实信息",
        "网页包含违法犯罪信息",
        "其他"
      ]
    };
  },
  mounted () {
    this.complanUrl = this.$store.state.searchUrl
  },
  watch: {
    complanUrl: function () {
      this.complanUrlWrong = true
      this.checkCanSubmit()
    },
    complanReason: function () {
      this.checkCanSubmit()
    },
    contact: function () {
      this.contactWrong = true
      this.checkCanSubmit()
    },
    complainSuccess: function (val) {
      if (val) {
        let timer = setInterval(() => {
          if (this.timeTurn == 0) {
            window.location.href = 'http://fanyi.youdao.com/'
            return
          }
          this.timeTurn = this.timeTurn - 1
        }, 1000)
      }
    }
  },
  methods: {
    submit() {
      // 是否可以提交
      if (!this.canSubmit) return;
      // 校验手机号
      if (this.contactWay == '手机') {
        if (!this.checkPhone(this.contact)) return false;
      }
      // 校验邮箱账号
      if (this.contactWay == '邮箱') {
        if (!this.checkEmail(this.contact)) return false;
      }
      // 校验QQ账号
      if (this.contactWay == 'QQ') {
        if (!this.checkQQ(this.contact)) return false;
      }
      // 校验微信号
      if (this.contactWay == '微信') {
        if (!this.checkWechat(this.contact)) return false;
      }
      // 校验投诉链接是否是合法链接
      if (!checkLink(this.complanUrl)){
        this.$message.error('网址格式有误，请输入正确网址');
        return false
      }
      window._rlog.push(["_trackEvent", 'webtranslation_complaint_submit']);
      let complanInfo = {
        reportUrl: encodeURI(this.complanUrl),
        reportContent: this.complanReason,
        reportDetails: this.complanDesc,
        contact: `${this.contactWay}:${this.contact}`
      }
      fanyiComplain(complanInfo).then((res) => {
        this.complainSuccess = true
      })
    },
    changeContactWay(index) {
      let contactOptions = this.contactOptions.concat();
      contactOptions.forEach((item, index) => {
        item.selected = false;
      });
      contactOptions[index].selected = true;
      this.contactOptions = contactOptions;
      this.contactWay = contactOptions[index].val
    },
    checkPhone(phone) {
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error('手机号码有误，请重填');
        this.contactWrong = false
        return false;
      } 
      return true
    },
    checkEmail(email) {
      let pattern = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (pattern.test(email)) {
        return true;
      } else {
        this.contactWrong = false
        this.$message.error('邮箱格式不正确！')
        return false;
      }
    },
    checkWechat(wechatCode) {
      if (!/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/.test(wechatCode)) {
        this.$message.error('微信号错误，请重填');
        this.contactWrong = false
        return false;
      } 
      return true
    },
    
    checkQQ(QQ){
      let reg = /^[1-9][0-9]{4,9}$/gim;
      if (reg.test(QQ)) {
        return true;
      } else {
        this.$message.error('QQ号格式错误，请重填');
        this.contactWrong = false
        return false;
      }
    },
    checkCanSubmit() {
      if (this.complanUrl !== '' && this.complanReason !== '' && this.contact !== '') {
        this.canSubmit = true
      } else {
        this.canSubmit = false
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.query.complainUrl != undefined && to.query.complainUrl != null) {
      next(vm => {
        vm.complanUrl = to.query.complainUrl
      })
    }
    next()
  },
  components: {
    YDFYTabBar,
    YDFYFooterBar
  }
};
</script>

<style scoped>
#complain .container {
  max-width: 1200px;
  min-width: 778px;
  padding: 0 160px;
  background-color: #FFFFFF;
  margin: 32px auto 136px;
  box-sizing: border-box;
  font-size: 0;
  overflow: hidden;
}
.container::-webkit-scrollbar {
  display: none;
}
#complain .content_wrong {
  border:1px solid rgba(224,36,51,1);
}
#complain .content_right {
  /* border:1px solid rgba(224,224,224,1); */
}
.container h5 {
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
  margin-bottom: 8px;
}
.container p {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin-bottom: 16px;
}

.container ul {
  height: 22px;
  margin-bottom: 24px;
}

li {
  float: left;
  margin-right: 32px;
}

.container .question_desc {
  margin-bottom: 8px;
}
.required,
.optional {
  display: inline-block;
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  line-height: 22px;
}
.segmentation {
  display: inline-block;
  margin: 0 7px 0 7px;
  height: 10px;
  border-left: 1px;
  border-style: solid;
  border-color: #E6E6E6;
}

.required {
  color: rgba(224, 36, 51, 1);
}
.optional {
  color: rgba(153, 153, 153, 1);
}
.no_submit {
  width: 90px;
  height: 33px;
  font-size: 12px;
  font-family: PingFangSC-Semibold;
  background: rgba(255, 221, 224, 1);
  color: rgba(255, 255, 255, 1);
  font-weight: bold;
  border-radius: 3px;
  border: 0;
  text-align: center;
  line-height: 33px;
}
.can_submit {
  width: 90px;
  height: 33px;
  font-family: PingFangSC-Semibold;
  font-size: 12px;
  background: rgba(224, 36, 51, 1);
  font-weight: bold;
  border-radius: 3px;
  border: 0;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 33px;
}
.contact {
  height: 36px;
  margin-bottom: 16px;
}
.contact_way {
  width: 36px;
  height: 36px;
}
.contact_way {
  float: left;
  margin-right: 32px;
}
.contact_way img {
  width: 36px;
  height: 36px;
}
.complain_success img {
  width: 96px;
  height: 96px;
  display: block;
  margin: 0 auto 24px;
}
.complain_success {
  margin-top: 196px;
}
.complain_success h5 {
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(21,174,47,1);
  line-height: 25px;
  margin-bottom: 8px;
  text-align: center;
}
.complain_success p {
  width: 100%;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153,153,153,1);
  line-height: 18px;
  text-align: center;
}
.complain_success p span {
  color: #E00012;
}
footer {
  position: fixed;
  left: 0;
  right: 0;
  height: 103px;
  bottom: 0;
}
</style>
<style>
.container .el-input {
  width: 100%;
  box-sizing: border-box;
  height: 38px;
  margin-bottom: 24px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.container .el-input__inner {
  font-size: 14px !important;
  font-weight: 400 !important;
  resize: none !important;
  color: rgba(51, 51, 51, 1) !important;
  padding: 0 18px !important;
  background: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(224,224,224,1);
  border-radius: 3px !important;
  width: 100%;
  box-sizing: border-box;
  height: 36px !important;
  font-style: normal !important;
}
.container .el-textarea__inner {
  resize: none !important;
}
textarea {
  width: 100%;
  height: 98px !important;
  box-sizing: border-box;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: rgba(51, 51, 51, 1) !important;
  line-height: 20px;
  padding: 9px 18px !important;
  box-sizing: border-box !important;
}
.container .el-textarea {
  margin-bottom: 24px !important;
}
.container .el-radio__input.is-checked + .el-radio__label {
  color: rgba(51, 51, 51, 1) !important;
}
.container .el-radio__input.is-checked .el-radio__inner {
  background: #f30027 !important;
  border-color: #f30027 !important;
}
/* .el-radio__label:hover {
  color: #E02433 !important;
} */
.el-radio__inner:hover {
  outline: none !important;
  border-color: #E02433 !important;
}
.el-input__inner:focus, .el-textarea__inner:focus { 
  /* outline: none !important; */
  border-color: #E02433 !important; ;
} 
</style>

